import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import Numeral from 'numeral';
import _ from 'lodash';

const BuyingProfile = ({ ...props }) => {
  BuyingProfile.propTypes = {
    row: PropTypes.number,
    opportunity: PropTypes.object,
    referral: PropTypes.object,
    property: PropTypes.object,
    userprofile: PropTypes.object
  };

  const listPriceMin = _.get(props.opportunity, 'listPriceMin', '');
  const listPriceMax = _.get(props.opportunity, 'listPriceMax', '');

  let priceRangeLabel = '';

  if (listPriceMin && listPriceMax) {
    priceRangeLabel = `$${Numeral(props.opportunity.listPriceMin).format('0,0')} - $${Numeral(props.opportunity.listPriceMax).format('0,0')}`;
  }

  if (listPriceMin && listPriceMax === '') {
    priceRangeLabel = `$${Numeral(props.opportunity.listPriceMin).format('0,0')} +`;
  }

  // Est Time Frame / Contingency Values
  let planningToSell = '';

  if (props.opportunity.isPlanningToSell === true) {
    planningToSell = 'Planning to Sell (Yes)';
  }

  if (props.opportunity.isPlanningToSell === false) {
    planningToSell = 'Planning to Sell (No)';
  }

  const contingency = (_.get(props.opportunity, 'contingency')) ? ` - ${props.opportunity.contingency}` : '';
  let timeFrameLabel = (props.opportunity.timeFrameInDays || props.opportunity.timeFrameInDays === 0) ? props.opportunity.timeFrame : '';

  ((props.opportunity.timeFrameInDays || props.opportunity.timeFrameInDays === 0) && planningToSell) ? timeFrameLabel += ` - ${planningToSell} ` : timeFrameLabel += planningToSell;

  if (contingency) {
    timeFrameLabel += contingency;
  }

  // Prequal Values
  let prequal = '';

  if (props.opportunity.isPrequalified === true) {
    prequal = 'Yes';
  }

  if (props.opportunity.isPrequalified === false) {
    prequal = 'No';
  }

  let prequalLabel = prequal;

  if (props.opportunity.isPrequalified === true) {
    const lender = (_.get(props.opportunity, 'prequalification.serviceProvider.companyName')) ? props.opportunity.prequalification.serviceProvider.companyName : '';
    const prequalAmount = (_.get(props.opportunity, 'prequalification.amount')) ? `$${Numeral(props.opportunity.prequalification.amount).format('0,0')}` : '';

    if (prequalAmount) {
      prequalLabel += ` - ${prequalAmount}`;
    }

    if (lender) {
      prequalLabel += ` - ${lender}`;
    }
  }

  const hasAreasOfInterest = props.opportunity.areasOfInterest && props.opportunity.areasOfInterest.length > 0;
  const hasPriceRange = !!priceRangeLabel;
  const hasTimeFrame = !!timeFrameLabel;
  const hasPrequal = !!prequalLabel;

  return (
    <div className='small-sm-down' style={{ position: 'relative' }}>
      {hasAreasOfInterest &&
        <div className='d-flex justify-content-between mb-3'>
          <div>
            <strong>Location(s) of Interest</strong>
            <div>
              {props.opportunity.areasOfInterest
                .map((location) => {
                  return location.value;
                })
                .join(', ')
              }
            </div>
          </div>
        </div>
      }

      {hasPriceRange &&
        <div className='mb-3'>
          <strong>Price Range</strong>
          <div>{priceRangeLabel}</div>
        </div>
      }

      {hasTimeFrame &&
        <div className='mb-3'>
          <strong>Est. Time Frame / Contingency</strong>
          <div>{timeFrameLabel}</div>
        </div>
      }

      {hasPrequal &&
        <div className='mb-3'>
          <strong>Pre-Qualification</strong>
          <div>{prequalLabel}</div>
        </div>
      }

      <div className='text-muted'>
        {`Updated: ${moment(props.opportunity.timestampModified).format('MM/DD/YY')}`}
      </div>
    </div>
  );
};
export default BuyingProfile;
